$( document ).ready(function() {
    /*var url = $(location).attr('href'),
    parts = url.split("/"),
    last_part = parts[parts.length-2],
    last_part_1 = parts[parts.length-1];
    var last_url = "/"+last_part+"/"+last_part_1;
    console.log("last_part_1:"+last_part_1);
    console.log(last_part);
    $('#AccessibleNav li a').each(function( index ) {
    	if(url == $(this).attr('href')){
            $(this).parent().addClass("active");
            console.log("if");
        }
    });
    $('.footer-links ul li a').each(function( index ) {
    	console.log($(this).attr('href'));
        if(last_url == $(this).attr('href'))
        {
          $(this).parent().addClass("active");
        }
    });*/
    $('.has-children').children('a').on('click', function(event){
      //prevent default clicking on direct children of .has-children 
      event.preventDefault();
      var selected = $(this);
      selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
    });
  //submenu items - go back link
  $('.go-back').on('click', function(){
    var selected = $(this),
        visibleNav = $(this).parent('ul').parent('.has-children').parent('ul');
    selected.parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('move-out');
  });
    if($("body").hasClass("template-product"))
    {
      var product_options = JSON.parse($('#ProductJson-product-template').html());
      console.log(product_options);
      var variations = product_options.variants;

      var checkedValue = $('.variant_option_1:checked').val();
      var option_two = [];
      for ( var i = 0, l = variations.length; i < l; i++ ) {
        var option = variations[i];
        if(option.option1 == checkedValue){
          //console.log(option.option2);
          option_two.push(option.option2);
        }
      }
      
      var checkedValueOpt2 = $('.variant_option_2:checked').val();
      var option_one = [];
      for ( var i = 0, l = variations.length; i < l; i++ ) {
        var option = variations[i];
        option_one.push(option.option2);
      }
	  console.log(option_one);
      $('input.variant_option_2').each(function(){
          var text_value = $(this).val();
          if(option_two.indexOf(text_value) !== -1){
              $('.product__notification').addClass('visually-hidden');
              $(this).click();
              $(this).closest('li').removeClass('unavailable');
              $(this).removeAttr('disabled');             	             
          } else {
              $(this).attr('disabled',true);
              $(this).removeAttr('checked');
              $(this).closest('li').addClass('unavailable');          	
          }
      });
    }
    $('.variant_option_1').change(function(){
      	/*var i;
        for (i = 0; i <= $(".variantopt").length; i++) {
          $(".variant-"+i).val($(this).val());
        }*/
         $(".variant-0").val($(this).val());
         $(".variant-0").change();
      	var val = $(this).val();
      	var option_two = [];
		for ( var i = 0, l = variations.length; i < l; i++ ) {
    		var option = variations[i];
          	if(option.option1 == val){
               	option_two.push(option.option2);
            }
		}
      	
      	$('input.variant_option_2').each(function(){
          console.log('option2');
        	var text_value = $(this).val();
			if(option_two.indexOf(text_value) !== -1){
              	$('.product__notification').addClass('visually-hidden');
              	$(this).click();
              	$(this).closest('li').removeClass('unavailable');
                $(this).removeAttr('disabled');             	             
            } else {
              	$(this).attr('disabled',true);
              	$(this).removeAttr('checked');
                $(this).closest('li').addClass('unavailable');          	
            }
        });
      	$('#productSelect--product-template > option').removeAttr('selected');
        $('#productSelect--product-template > option').each(function() {
          console.log($(".variant-0").val()+" / "+$(".variant-1").val());
          if($(".variant-0").val() == "Glass")
          {
            console.log('Show Glass Section');
            $(this).attr('selected','selected');
            $(this).val($(this).val());
             $(".liquid_protections").hide();
          $(".tempered_glass").show();
          }
         if($(".variant-0").val() == "Liquid")
          {
            console.log('Show liquid Section');
            $(".tempered_glass").hide();
          $(".liquid_protections").show();
          }
        });
    });
  
  	$('.variant_option_2').change(function(){
         $(".variant-1").val($(this).val());
         $(".variant-1").change();
      	
      	  var val = $(this).val();
          var option_one = [];
          for ( var i = 0, l = variations.length; i < l; i++ ) {
              var option = variations[i];
            console.log(val);
              if(option.option2 == val){
                  option_one.push(option.option1);
              }
          }
		  console.log(option_one);
          $('input.variant_option_1').each(function(){
              var text_value = $(this).val();
              if(option_one.indexOf(text_value) !== -1){
                  $('.product__notification').addClass('visually-hidden');
                  $(this).click();
                  $(this).closest('li').removeClass('unavailable');
                  $(this).removeAttr('disabled');             	             
              } else {
                  $(this).attr('disabled',true);
                  $(this).removeAttr('checked');
                  $(this).closest('li').addClass('unavailable');          	
              }
          });
         $('#productSelect--product-template > option').removeAttr('selected');
         $('#productSelect--product-template > option').each(function() {
           console.log($(".variant-0").val()+" / "+$(".variant-1").val());
           if($(this).data("title") == $(".variant-0").val()+" / "+$(".variant-1").val())
           {
             $(this).attr('selected','selected');
             $(this).val($(this).val());
           }
         });
    });
  
    $('.variant_option_3').change(function(){
         $(".variant-2").val($(this).val());
         $(".variant-2").change();
    });
  
    $('.variant_option_4').change(function(){
         $(".variant-3").val($(this).val());
         $(".variant-3").change();
    });
  
    $('input:radio[name="opt2"]').change(function(){
        if($(this)[0].checked){
           console.log($(this).val());
        }
       else
       {
         console.log("Not checked");
       }
    });
    
  
    $('.logo_inner-slider').owlCarousel({
      loop:true,
      margin:10,
      autoplay:true,
      autoplayTimeout:5000,
      responsiveClass:true,
      responsive:{
          0:{
              items:1,
              nav:true
          },
          600:{
              items:3,
              nav:false
          },
          1000:{
              items:6,
              nav:true,
              loop:false
          }
      }
  });
 
  
     $('#home-banner').owlCarousel(
  {
      loop:true,
      margin:0,
      autoplay:true,
      autoplayTimeout:5000,
      responsiveClass:true,
      nav:false,
    dots: true,
    items: 1
  });
 
  $('.mega-menu-slider').owlCarousel(
  {
      loop:true,
      margin:10,
      autoplay:true,
      autoplayTimeout:5000,
      responsiveClass:true,
      nav:true,
      dots: false,
      responsive:{
          0:{
              items:1,
              nav:true
          },
          600:{
              items:1,
              nav:false
          },
          1000:{
              items:1,
              nav:true,
              loop:false
          }
      }
  });
  
    $('.mobile').owlCarousel({
      loop:false,
      margin:10,
      responsiveClass:true,
      nav:true,
      dots: false,
              items:5,
      responsive:{
          0:{
              items:2,
              nav:true
          },
          600:{
              items:3,
              nav:true
          },
          1000:{
              items:5,
              nav:true
          }
      }
  });
  $('#testimonial-slider').owlCarousel({
      loop:true,
      stagePadding: 130,
      margin: 30,
      autoplay:false,
      autoplayTimeout:5000,
      responsiveClass:true,
      nav:true,
      dots: false,
    
      responsive:{
          0:{
              items:1,
            stagePadding: 0
          },
          768:{
              items:1,
            stagePadding: 0
          },
          990:{
              items:1,
              nav:true,
            
          }
      }
  });
  $(".your_device li").click(function () {
        window.location.href = $(this).data("pvalue");
  });
  $(".lbl_your_device").click(function() {
    $(this).next("ul").toggle();
    $(this).toggleClass("show");
  });
  if (window.location.href.indexOf("variant=") == -1) {
    setTimeout(function(){  
      $(".variant_option_1:first").click();
      $(".variant_option_1:first").attr("checked",true);
      if($(".variant_option_1").first().val() == "Glass" || $(".variant_option_1").first().val() == "glass")
      {
          $(".variant_option_1:first").click();
          $(".variant_option_1:first").attr("checked",true);
      }
      else
      {
          $(".variant_option_1:last").click();
          $(".variant_option_1:last").attr("checked",true);
      }
      $('#productSelect--product-template > option').each(function() {
        console.log($(this).data("title") );
        console.log("302")
        if($(this).data("title") == "No Coverage / Glass")
        {
          
          $(this).attr('selected','selected');
          $(this).val($(this).val());
        }
      });
    }, 500);
  }
  $('[data-toggle="tooltip"]').tooltip();
  
  $('input.variant_option_1').each(function(){
      var text_value = $(this).val();
      if($(this).is(":checked")){
        console.log($(this).val());
        if($(this).val() == "Glass")
        {
          console.log($(this).val());
          $(".liquid_protections").hide();
          $(".tempered_glass").show();
        }
        if($(this).val() == "Liquid")
        {
          console.log($(this).val());
          $(".tempered_glass").hide();
          $(".liquid_protections").show();
        }
      } 
  });
});
